import React from 'react';

const Icon = ({ size = '40', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...other}>
            <path
                d="m15.391 5.983-4.681-.007-.168.009c-.274.031-.532.14-.745.312a1.42 1.42 0 0 0-.455.66l-1.438 4.378-3.79 2.7-.144.117a1.4 1.4 0 0 0-.382 1.473L5.045 20 3.59 24.373l-.046.177a1.4 1.4 0 0 0 .077.79c.1.25.272.467.494.624l3.79 2.7 1.438 4.38.06.155c.115.247.3.456.531.602.232.146.502.224.777.223l4.681-.009 3.784 2.715.155.098a1.45 1.45 0 0 0 1.53-.1l3.783-2.713 4.683.009.168-.009c.273-.031.531-.14.744-.312.213-.172.37-.401.455-.66l1.436-4.38 3.792-2.699.144-.116a1.412 1.412 0 0 0 .382-1.473L34.99 20l1.456-4.373.046-.177a1.4 1.4 0 0 0-.076-.79 1.42 1.42 0 0 0-.495-.624l-3.792-2.7-1.434-4.38-.062-.155a1.423 1.423 0 0 0-.531-.602 1.448 1.448 0 0 0-.776-.223l-4.683.007L20.86 3.27a1.447 1.447 0 0 0-1.685 0L15.39 5.983Zm4.626.183 3.319 2.383.152.095c.212.115.45.176.693.175l4.103-.01 1.263 3.841.066.169c.104.217.262.404.459.544l3.32 2.363-1.273 3.832-.046.174a1.4 1.4 0 0 0 .046.709l1.273 3.832-3.32 2.364-.14.114c-.179.164-.312.37-.387.599l-1.261 3.84-4.103-.01-.181.012c-.24.03-.469.119-.665.26l-3.318 2.38-3.316-2.38-.153-.096a1.449 1.449 0 0 0-.693-.175l-4.105.008-1.26-3.84-.068-.168a1.421 1.421 0 0 0-.459-.544l-3.321-2.364 1.274-3.831.046-.174a1.4 1.4 0 0 0-.046-.709l-1.274-3.833 3.321-2.363.141-.114c.178-.164.31-.37.386-.599l1.26-3.84 4.103.01c.304 0 .6-.095.847-.271l3.317-2.383Z"
                fill="url(#a)"
            />

            <path
                d="M26.19 14.412c.246-.253.576-.4.922-.411.346-.011.684.115.944.352a1.446 1.446 0 0 1 .177 1.922l-.114.133-7.7 7.971a2.016 2.016 0 0 1-1.343.618 2 2 0 0 1-1.396-.472l-.156-.146-3.609-3.736a1.436 1.436 0 0 1-.397-.954c-.01-.358.111-.707.34-.976a1.33 1.33 0 0 1 1.857-.183l.129.117 3.127 3.235 7.22-7.47Z"
                fill="url(#b)"
            />

            <defs>
                <linearGradient id="a" x1="33.654" y1="44.72" x2="-2.521" y2="43.952" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FE6E00" />

                    <stop offset="1" stopColor="#F7A202" />
                </linearGradient>
                <linearGradient id="b" x1="27.216" y1="27.498" x2="10.78" y2="27.007" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FE6E00" />

                    <stop offset="1" stopColor="#F7A202" />
                </linearGradient>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
